import ar from "./ar.json";
import es from "./es.json";
import fil from "./fil.json";
import fr from "./fr.json";
import hi from "./hi.json";
import pa from "./pa.json";
import sw from "./sw.json";
import vi from "./vi.json";

export const stage2ReviewStatus = {
  activeBundle: "stage2-gpt",
  reviewLabel: "machine-assisted, needs review",
  productionReady: false,
  productionReviewPriority: [
    "Spanish first",
    "Arabic and Punjabi next",
    "Payment and compliance-sensitive strings across all languages"
  ],
  qaReportPath: "i18n/reports/stage3/stage3-summary.md"
};

export const stage2Translations = {
  ar,
  es,
  fil,
  fr,
  hi,
  pa,
  sw,
  vi
};
